'use strict';

// ;(function (global, undefined) {
var ABL = {
    _token: $.jStorage.get("localToken"),
    queryObj: {
        page: 1
    },
    pageInfo: albumPageInfo
};
ABL.init = function (params) {
    UTL.reachBottom(ABL.reachBottomCb);
};

ABL.reachBottomCb = function () {
    var $isShow = $('#projectsAlbumDisplay').hasClass('be-hide');
    if (!ABL.pageInfo || $isShow) return;
    if (ABL.queryObj.page >= ABL.pageInfo.pages && ABL.pageInfo.count > 0) {
        $('.bottom-line').slideDown();
        return;
    }
    ABL.queryObj.page++;
    ABL.getAlbumList(ABL.queryObj, ABL.renderList);
};

ABL.getAlbumList = function (query, cb) {
    showLoadingGif();
    $.ajax({
        url: v1url + PAY.api.getAlbumList,
        type: "GET",
        data: query,
        headers: {
            token: ABL._token
        },
        dataType: "json",
        success: function success(data) {
            if (data.code == 1000) {
                var data = data.data;
                ABL.pageInfo = data.page;
                cb && cb(data.list);
                closeLoadingGif();
            } else if (data.code == -1) {
                UTL.showPCLoginForm();
            } else if (data.code == 1006) {
                $("#payModal").modal('show');
            }
        },
        error: function error() {}
    });
};

ABL.renderList = function (list) {
    list = list || [];
    var $albumListWrap = $('#albumListDom .album-list-container');
    var _html = '';
    for (var i = 0, l = list.length; i < l; i++) {
        var item = list[i];
        _html += '\n                <div class="album-item">\n                    <a href="/album/' + item.id + '" target="_blank">\n                        <div class="album-item-wrap">\n                            <div class="album-item-img-wrap">\n                                <img src="' + (item.image_url ? item.image_url : '/imgs/pay/index/album_default.png') + '" alt="" />\n                            </div>\n                            <div class="album-item-title">\n                                ' + item.name + '\n                            </div>\n                        </div>\n                    </a>\n                </div>\n            \n            ';
    }
    $albumListWrap.append(_html);
};

// global.ABL = ABL;
// })(undefined);